export const en: Record<string, string> = {
  'delivery.title': "Where should we deliver your order?",
  'delivery.beforeSignup': "Check delivery availability before entering your personal details.",
  'delivery.country': "Delivery country",
  'delivery.choose': "Choose your delivery country",
  'delivery.availableTo': "Delivery to:",
  'delivery.blocked': "Some items cannot be delivered to the selected country. Your cart has been kept. Choose another delivery country or remove the unavailable items.",
  'delivery.backToCart': "Return to your cart",
  'delivery.updateAddress': "Update delivery address",
  'delivery.checkFailed': "We could not check delivery availability. Your cart has been kept. Please try again.",
  'delivery.retry': "Try again",
  'delivery.checking': "Checking delivery availability…",
  // ── main.tsx (add-to-cart delegate) ──
  'cart.adding': 'Adding...',
  'cart.added': 'Added',
  'cart.addSuccess': 'Product added to cart',
  'cart.addFail': 'Failed to add product: {error}',
  'widget.unavailable': 'Service unavailable',

  // ── App.tsx (InlineViewRoot) ──
  'inline.loginRequired': 'Please log in to view this page.',
  'inline.loginLink': 'log in',
  'inline.loginRequiredPrefix': 'Please ',
  'inline.loginRequiredSuffix': ' to view this page.',
  'inline.subscriptionsAuthRedirect':
    'Newsletter subscriptions are only available to signed-in customers. Sign in to continue.',
  'inline.redirectingToLogin': 'Redirecting…',

  // ── AccountOverlay (TITLES + auth choice) ──
  'title.discounts': 'Your personal discount',
  'title.bonusTransactions': 'Bonus transactions',
  'title.account': 'My account',
  'title.bonusAccount': 'Referral Program',
  'title.referralTree': 'Referral Tree',
  'title.orders': 'My orders',
  'title.subscriptions': 'Subscriptions',
  'title.tickets': 'Tickets',
  'title.accountDelete': 'Delete Account',
  'title.signup': 'Sign up',
  'title.cart': 'Shopping Cart',
  'title.catalog': 'Catalog',
  'title.checkout': 'Checkout',
  'title.checkoutQnr': 'Medical Questionnaire',
  'title.checkoutConfirm': 'Order Confirmation',
  'title.orderSuccess': 'Order Placed',
  'title.orderReturn': 'Payment status',
  'title.checkoutAuth': 'Log in or Register',
  'title.checkoutLogin': 'Log in',
  'checkout.authPrompt': 'Please log in or register to continue to checkout.',
  'checkout.authLogin': 'Log in',
  'checkout.authSignup': 'Sign up',
  'overlay.underConstruction': 'This section is under construction.',

  // ── AccountOverlay (CheckoutLoginForm) ──
  'login.title': 'Sign in',
  'login.loginLabel': 'Login',
  'login.loginPlaceholder': 'Email or username',
  'login.passwordLabel': 'Password',
  'login.loginRequired': 'Login is required',
  'login.passwordRequired': 'Password is required',
  'login.invalidCredentials': 'Invalid email or password.',
  'login.noAccount': "Don't have an account?",
  'login.signupLink': 'Sign up',
  'login.submit': 'Sign in',

  // ── AuthWidget ──
  'auth.discount': 'Your personal discount!',
  'auth.bonusAccount': 'Your bonus account',
  'auth.myAccount': 'My account',
  'auth.referral': 'Referral Program',
  'auth.orders': 'My orders',
  'auth.subscriptions': 'Subscriptions',
  'auth.tickets': 'Tickets',
  'auth.deleteAccount': 'Delete Account',
  'auth.logout': 'Logout',
  'auth.signup': 'Sign up',
  'auth.login': 'Login',
  'auth.loginModal.title': 'Please, login',
  'auth.loginModal.emailLabel': 'Email or login',
  'auth.loginModal.emailPlaceholder': 'Email or login',
  'auth.loginModal.passwordLabel': 'Password',
  'auth.loginModal.passwordPlaceholder': 'Password',
  'auth.loginModal.emailRequired': 'Login is required',
  'auth.loginModal.passwordRequired': 'Password is required',
  'auth.loginModal.error': 'Invalid email or password. Please try again.',
  'auth.loginModal.remindPassword': 'Remind password?',
  'auth.loginModal.noAccount': "If you don't have account yet,",
  'auth.loginModal.signupLink': 'Sign up',
  'auth.loginModal.submit': 'Sign in',
  'auth.loginModal.close': 'Close',

  // ── Forgot / Reset password ──
  'title.forgotPassword': 'Reset password',
  'title.resetPassword': 'Set new password',
  'forgotPassword.emailLabel': 'Email',
  'forgotPassword.emailPlaceholder': 'you@example.com',
  'forgotPassword.submit': 'Send code',
  'forgotPassword.success': 'We sent a 10-character code to your email.',
  'forgotPassword.successHint': 'Enter the code on the next page to set a new password.',
  'forgotPassword.goToSetPassword': 'Enter code and set password',
  'forgotPassword.backToLogin': 'Back to login',
  'forgotPassword.invalidEmail': 'Enter a valid email address',
  'resetPassword.emailLabel': 'Email',
  'resetPassword.resetCodeLabel': 'Code from email',
  'resetPassword.resetCodePlaceholder': '10 characters',
  'resetPassword.resetCodeFormat': 'Code must be exactly 10 letters or numbers',
  'resetPassword.newPasswordLabel': 'New password',
  'resetPassword.confirmLabel': 'Confirm password',
  'resetPassword.passwordPlaceholder': '••••••••',
  'resetPassword.passwordMin': 'Password must be at least 5 characters',
  'resetPassword.passwordMismatch': 'Passwords do not match',
  'resetPassword.submit': 'Save',
  'resetPassword.success': 'Password updated. You can now sign in.',
  'resetPassword.redirectHint': 'Redirecting...',

  // ── CartWidget ──
  'cartWidget.cart': 'Cart',
  'cartWidget.shoppingCart': 'Shopping Cart',
  'cartWidget.items': 'items',
  'cartWidget.viewCart': 'VIEW CART',

  // ── CartPage ──
  'cartPage.product': 'Product',
  'cartPage.qty': 'Qty',
  'cartPage.price': 'Price',
  'cartPage.lineTotal': 'Total',
  'cartPage.loading': 'Loading cart...',
  'cartPage.empty': 'Shopping cart is empty',
  'cartPage.startShopping': 'Start Shopping',
  'cartPage.recalculate': 'Recalculate',
  'cartPage.remove': 'Remove',
  'cartPage.free': 'Free',
  'cartPage.quickNotes': 'Quick notes',
  'cartPage.note1': '1. Shipping insurance guarantees a refund or reship.',
  'cartPage.note2': '2. Bitcoin payment gives 10% discount.',
  'cartPage.note3': '3. Enter valid discount coupon below.',
  'cartPage.note4': '4. Some discounts activate after payment selection.',
  'cartPage.ukusNote1': 'Shipping insurance guarantees a refund or reship of your order.',
  'cartPage.ukusNote3': 'Enter a valid coupon below to deduct the discount from your total.',
  'cartPage.ukusNote4': 'Some discounts activate after you pick a payment method.',
  'cartPage.note2HowTo': 'how to',
  'cartPage.couponTitle': 'Discount coupon',
  'cartPage.couponPlaceholder': 'Enter a coupon here',
  'cartPage.couponLabel': 'Enter code',
  'cartPage.couponSubmit': 'Apply',
  'cartPage.orderSummary': 'Order summary',
  'cartPage.subtotalLabel': 'Subtotal',
  'cartPage.personalDiscountLabel': 'Personal discount',
  'cartPage.bonusDiscountLabel': 'Bonus discount',
  'cartPage.couponLabelRow': 'Coupon',
  'cartPage.shippingLabel': 'Shipping',
  'cartPage.shippingInsuranceLabel': 'Shipping insurance',
  'cartPage.totalLabel': 'Total',
  'cartPage.freeShort': 'Free',
  'cartPage.emptyTitle': 'Your shopping cart is empty',
  'cartPage.emptyLead': 'Add a pack from the catalog — prices and shipping show before checkout.',
  'cartPage.browseCatalog': 'Browse catalog',
  'cartPage.trustTracked': 'Tracked shipping',
  'cartPage.trustDiscreet': 'Discreet packaging',
  'cartPage.trustRefunds': 'Clear refunds',
  'cartPage.trustSupport': 'Real support',
  'cartPage.payTitle': 'Pay your way',
  'cartPage.payLead': 'Debit (incl. Amex), eCheque, or bitcoin — no credit cards. Methods shown at checkout.',
  'cartPage.payDebit': 'Debit card · Amex OK',
  'cartPage.payEcheque': 'eCheque',
  'cartPage.payBitcoin': 'Bitcoin · 10% off',
  'cartPage.needHelp': 'Need help?',
  'cartPage.helpLiveChat': 'live chat',
  'cartPage.helpEmail': 'email',
  'cartPage.helpTickets': 'tickets',
  'cartPage.helpOrdering': 'Ordering process?',
  'cartPage.helpOrderingBody': 'Orders go through a secure server.',
  'cartPage.helpDelivery': 'Delivery time?',
  'cartPage.helpDeliveryBody': 'Usually 14–28 working days via registered airmail.',
  'cartPage.helpPrivacy': 'Privacy?',
  'cartPage.helpPrivacyBody': 'We don’t disclose personal or payment details to third parties.',
  'cartPage.learnMore': 'Learn more',
  'cartPage.couponInvalid': 'The coupon is invalid or expired.',
  'cartPage.couponSuccess': 'The coupon has been added successfully.',
  'cartPage.couponNotApplied': 'The coupon was not applied. It is either invalid, restricted for the selected payment method, or does not meet the promotion program\'s requirements.',
  'cartPage.couponCleared': 'Coupon has been removed.',
  'cartPage.itemRemoved': 'Item removed from cart.',
  'cartPage.removeFailed': 'Failed to remove item.',
  'cartPage.updateQtyFailed': 'Failed to update quantity.',
  'cartPage.qtyDecrease': 'Decrease quantity',
  'cartPage.qtyIncrease': 'Increase quantity',
  'cartPage.maxPillsHint': 'Max {pills} pills ({packs} packs)',
  'cartPage.deliveryMethod': 'Delivery method:',
  'cartPage.standard': 'Standard',
  'cartPage.subtotal': 'Subtotal:',
  'cartPage.personalDiscount': 'Personal Discount:',
  'cartPage.bonusDiscount': 'Bonus Discount:',
  'cartPage.discountCoupon': 'Discount Coupon:',
  'cartPage.clearCoupon': 'Clear coupon',
  'cartPage.shippingCost': 'Shipping cost:',
  'cartPage.discounted': 'discounted',
  'cartPage.freeShipping': 'free shipping',
  'cartPage.shippingInsurance': 'Shipping Insurance:',
  'cartPage.total': 'Total:',
  'cartPage.backToShopping': 'Back to shopping',
  'cartPage.checkout': 'Checkout',
  'shippingMethod.airmail_service': 'Airmail Service',

  // ── CheckoutStepper ──
  'stepper.cart': 'Cart',
  'stepper.payment': 'Payment',
  'stepper.medical': 'Medical',
  'stepper.confirm': 'Confirm',

  // ── CheckoutMiniCart ──
  'miniCart.bonus': 'Bonus:',
  'miniCart.free': 'Free',
  'miniCart.subtotal': 'Subtotal:',
  'miniCart.personalDiscount': 'Personal Discount:',
  'miniCart.bonusDiscount': 'Bonus Discount:',
  'miniCart.discountCoupon': 'Discount Coupon:',
  'miniCart.shippingCost': 'Shipping cost:',
  'miniCart.freeShipping': 'free shipping',
  'miniCart.shippingInsurance': 'Shipping Insurance:',
  'miniCart.total': 'Total:',
  'miniCart.editCart': 'Edit Cart',

  // ── CheckoutPage ──
  'checkout.loading': 'Loading checkout...',
  'checkout.cartEmpty': 'Your cart is empty.',
  'checkout.backToShop': 'Back to Shop',
  'checkout.backToConfirm': 'Back to Order Confirmation',
  'checkout.selectPayment': 'Select a payment method',
  'checkout.ccType': 'Credit card type',
  'checkout.ccNumber': 'Credit card number (no spaces or dashes)',
  'checkout.expDate': 'Expiration date',
  'checkout.cvv': 'CVV2',
  'checkout.checkNumber': 'Check Number',
  'checkout.bankName': 'Bank name',
  'checkout.routingNumber': 'Routing Number (ABA Code)',
  'checkout.accountNumber': 'Account Number',
  'checkout.routingHint': 'Routing Number (ABA Code) — Usually 9 digits on your check.',
  'checkout.accountHint': 'Account Number — Usually comes before the check number; location varies.',
  "checkout.cryptoTitle": "Pay with crypto",
  "checkout.cryptoStep1": "Click Continue.",
  "checkout.cryptoStep2": "Choose your coin and network on the next page.",
  "checkout.cryptoStep3": "Follow the payment instructions to complete your payment.",
  "checkout.cryptoCoinsLabel": "Available coins",
  "checkout.cryptoCoins": "Ethereum · Litecoin · Bitcoin Cash · Dogecoin · Monero · Tron · XRP · Cardano · TON · BNB",
  "checkout.cryptoNetworks": "Choose Ethereum (ERC-20), Tron (TRC-20) or BNB Smart Chain (BEP-20).",
  "checkout.cryptoBitcoinTitle": "Want to pay with Bitcoin (BTC)?",
  "checkout.cryptoBitcoinNote": "Select the separate Bitcoin payment option at checkout.",
  'checkout.btcTitle': "Pay with Bitcoin",
  'checkout.btcStep1': "Place your order to open the payment page.",
  'checkout.btcStep2': "Send the exact BTC amount to the address shown, using the specified network.",
  'checkout.btcStep3': "Pay before the payment details expire.",
  'checkout.btcOrderNote': "Use these payment details for this order only. No phone confirmation needed.",
  'checkout.btcHelp': "How to buy Bitcoin",
  'checkout.continue': 'Continue',
  'checkout.processing': 'Processing...',
  'checkout.noPayments': 'Unfortunately, no payments are available for checkout. Please contact the sales or support department.',
  'checkout.paymentFailed': 'Failed to set payment method',
  'checkout.error': 'An error occurred',

  // ── Checkout validation ──
  'validate.ccEmpty': "Card Number can't be empty",
  'validate.ccInvalid': 'Card number is not valid',
  'validate.ccAmex': 'Amex Card Number must be valid',
  'validate.ccMaster': 'MasterCard Number must be valid',
  'validate.ccVisa': 'Visa Card Number must be valid',
  'validate.ccTypeEmpty': 'Card Type must not be empty',
  'validate.expEmpty': 'Expiration date is required',
  'validate.fieldInvalid': 'Please check this field',
  'validate.cvvDigits': 'Card CVV2 must be 3-4 digits',
  'validate.cvvEmpty': "CVV2 can't be empty",
  'validate.bankEmpty': "Bank name can't be empty",
  'validate.bankLength': 'Bank Name must have a length between 1 and 32',
  'validate.chequeEmpty': "Cheque Number can't be empty",
  'validate.chequeDigits': 'Cheque Number must contain only digits',
  'validate.chequeLength': 'Cheque Number must have a length between 1 and 16',
  'validate.routingEmpty': "Routing Number can't be empty",
  'validate.routingDigits': 'Routing Number must contain only digits',
  'validate.routingLength': 'Routing Number must have a length between 1 and 16',
  'validate.accountEmpty': "Account number can't be empty",
  'validate.accountDigits': 'Account Number must contain only digits',
  'validate.accountLength': 'Account Number must have a length between 1 and 16',

  // ── CheckoutConfirmPage ──
  'confirm.loadFailed': 'Failed to load order details',
  'confirm.title': 'Order Confirmation',
  'confirm.shippingAddress': 'Shipping Address',
  'confirm.edit': 'Edit',
  'confirm.paymentMethod': 'Payment Method',
  'confirm.notSelected': 'Not selected',
  'confirm.shippingNote': '*US2US shipping is typically 3 business days after dispatch (up to 5 business days).',
  'confirm.overseasShippingNote': '*Overseas shipping time is typically 14-28 business days for EU and Indian products.',
  'confirm.manufacturerNote': '*We have several manufacturers of this product. If the manufacturer you ordered is currently out of stock, we will contact you and offer an alternative.',
  'confirm.agreePolicy': 'I hereby declare that I agree with Refund Policy and Chargebacks Policy',
  'confirm.retentionConsent': 'I agree to receive promotional emails and reminders about my orders',
  'confirm.back': 'Back',
  'confirm.placing': 'Placing Order...',
  'confirm.placeOrder': 'Place Order',
  'confirm.previewModeNotice': 'Preview mode — placing real orders is disabled.',
  'confirm.success': 'Order placed successfully!',
  'confirm.invalidResponse': 'Invalid order response',
  'confirm.failed': 'Failed to place order',
  'confirm.error': 'An error occurred',

  // ── CheckoutQnrPage ──
  'qnr.loading': 'Loading questionnaire...',
  'qnr.loadFailed': 'Failed to load questionnaire',
  'qnr.retry': 'Retry',
  'qnr.title': 'Medical Questionnaire',
  'qnr.orderTotal': 'Order Total:',
  'qnr.intro': 'Please fill in this form to request the prescription for the medication you ordered. It is the same information you would be asked if you visited a clinic or physician.',
  'qnr.general': 'General information',
  'qnr.dob': "Patient's Date of Birth",
  'qnr.day': 'Day',
  'qnr.month': 'Month',
  'qnr.year': 'Year',
  'qnr.dobRequired': 'Date of birth is required',
  'qnr.gender': 'Gender',
  'qnr.selectPlaceholder': 'Select...',
  'qnr.genderRequired': 'Gender is required',
  'qnr.height': "Patient's Height",
  'qnr.heightRequired': 'Height is required',
  'qnr.weight': "Patient's Weight",
  'qnr.weightRequired': 'Weight is required',
  'qnr.medicalHistory': 'Medical History',
  'qnr.disorderQuestion': 'What is the disorder or complaint for which you request this medication?',
  'qnr.conditionRequired': 'Medical condition is required',
  'qnr.otherDisease': 'Do you have any other disease, disorder or medical problem?',
  'qnr.yesNo': 'Please answer yes or no',
  'qnr.specifyOther': 'If yes, please specify',
  'qnr.specifyRequired': 'Please specify other medical problems',
  'qnr.confirmations': 'Confirmations',
  'qnr.declaration': 'I declare that the information I have given is complete and without reserve...',
  'qnr.declarationRequired': 'Declaration is required',
  'qnr.responsibility': 'Customer Responsibility Statement',
  'qnr.responsibilityRequired': 'Responsibility statement is required',
  'qnr.consent': 'I declare that I Agree with the Informed Consent Agreement',
  'qnr.consentRequired': 'Consent agreement is required',
  'qnr.yes': 'Yes',
  'qnr.no': 'No',
  'qnr.back': 'Back',
  'qnr.saving': 'Saving...',
  'qnr.continue': 'Continue',
  'qnr.saved': 'Medical questionnaire saved',
  'qnr.saveFailed': 'Failed to save questionnaire',

  // ── OrderSuccessPage ──
  'orderSuccess.placedSuccess': 'Your order has been successfully placed.',
  'orderSuccess.thanks': 'Thank you! Your order has been placed.',
  'orderSuccess.orderId': 'Order ID:',
  'orderSuccess.description': 'You will receive an order confirmation by email. We will process your order as soon as possible.',
  'orderSuccess.orderDetails': 'Order details',
  'orderSuccess.viewOrders': 'View my orders',
  'orderSuccess.close': 'Close',

  // ── OrderReturnPage ──
  'orderReturn.successTitle': 'Thank you!',
  'orderReturn.successLead': 'Your payment has been received.',
  'orderReturn.successHint': 'A confirmation email has been sent. Shipping updates will follow.',
  'orderReturn.cancelTitle': 'Payment cancelled',
  'orderReturn.cancelLead': 'No payment was taken for this order.',
  'orderReturn.cancelHint': 'After checkout your cart is cleared. Use order details or Try again below to complete payment.',
  'orderReturn.failureTitle': 'Payment failed',
  'orderReturn.failureLead': 'We could not complete your payment for this order.',
  'orderReturn.failureHint': 'Your cart was cleared when the order was placed. Try again, view order details, or contact support.',
  'orderReturn.btnDetails': 'View order details',
  'orderReturn.btnSignIn': 'Sign in to view details',
  'orderReturn.btnContinueShopping': 'Continue shopping',
  'orderReturn.btnContactSupport': 'Contact support',
  'orderReturn.btnTryAgain': 'Try again',

  // ── ProfileView ──
  'profile.loading': 'Loading profile...',
  'profile.loadFailed': 'Failed to load profile data',
  'profile.personalInfo': 'Personal Information',
  'profile.title': 'Title',
  'profile.mr': 'Mr.',
  'profile.mrs': 'Mrs.',
  'profile.ms': 'Ms.',
  'profile.firstName': 'First name',
  'profile.lastName': 'Last name',
  'profile.email': 'E-Mail',
  'profile.phone': 'Phone',
  'profile.billingAddress': 'Billing Address',
  'profile.address': 'Address',
  'profile.zipcode': 'Zipcode',
  'profile.city': 'City',
  'profile.country': 'Country',
  'profile.state': 'State',
  'profile.selectCountry': 'Select Country',
  'profile.stateProvince': 'State / Province',
  'profile.selectState': 'Select State',
  'profile.shippingAddress': 'Shipping Address',
  'profile.sameAsBilling': 'Same as billing address',
  'profile.changePassword': 'Change Password',
  'profile.passwordHint': "Leave blank if you don't want to change your password.",
  'profile.newPassword': 'New Password',
  'profile.confirmPassword': 'Confirm Password',
  'profile.firstNameRequired': 'First name is required',
  'profile.lastNameRequired': 'Last name is required',
  'profile.emailRequired': 'Email is required',
  'profile.emailInvalid': 'Invalid email format',
  'profile.phoneRequired': 'Phone is required',
  'profile.addressRequired': 'Address is required',
  'profile.zipcodeRequired': 'Zipcode is required',
  'profile.cityRequired': 'City is required',
  'profile.countryRequired': 'Country is required',
  'profile.passwordMismatch': 'Passwords do not match',
  'profile.passwordMinLength': 'Password must be at least 5 characters',
  'profile.updateSuccess': 'Profile updated successfully',
  'profile.updateFailed': 'Update failed',
  'profile.saving': 'Saving...',
  'profile.updateProfile': 'Update Profile',

  // ── TelegramPanel ──
  'telegram.title': 'Telegram notifications',
  'telegram.hint': 'Link Telegram to get order updates, tracking alerts, and support chat on your phone.',
  'telegram.orderFcTitle': 'Confirm your order via Telegram',
  'telegram.orderFcIntro': 'This order requires a quick confirmation of your details before we can send payment instructions (standard while your account is not yet fully verified).',
  'telegram.orderFcFastest': 'Fastest option: connect Telegram below. After you place the order, the bot will send a confirmation prompt — usually much quicker than waiting for a phone call.',
  'telegram.orderFcAlternatively': 'Alternatively: confirm by phone or',
  'telegram.liveChat': 'live chat',
  'telegram.orderFcReady': 'We can send the confirmation prompt to your Telegram. Check the bot chat if you have not already.',
  'telegram.orderInfoTitle': 'Stay updated in Telegram',
  'telegram.orderInfoIntro': 'Connect our support bot for:',
  'telegram.orderInfoItem1': 'Order status and shipping updates',
  'telegram.orderInfoItem2': 'Tracking scans and delivery alerts',
  'telegram.orderInfoItem3': 'Payment reminders when needed',
  'telegram.orderInfoItem4': 'Direct chat with support from your phone',
  'telegram.statusLoading': 'Checking Telegram connection…',
  'telegram.unavailable': 'Telegram connection is not available right now.',
  'telegram.connected': 'Telegram connected',
  'telegram.connectedAt': 'Connected',
  'telegram.boundFrom': 'Connected from',
  'telegram.connect': 'Connect Telegram',
  'telegram.connecting': 'Connecting…',
  'telegram.linkReady': 'Open Telegram and tap Start to finish linking your account.',
  'telegram.openTelegram': 'Open Telegram',
  'telegram.copyLink': 'Copy link',
  'telegram.copied': 'Copied',
  'telegram.expiresMinutes': 'Link expires in about {minutes} minutes.',
  'telegram.notificationsTitle': 'Notification preferences',
  'telegram.notificationsHint': 'Order confirmation and support chat always work. Choose optional alerts below.',
  'telegram.notificationsSaving': 'Saving…',
  'telegram.notificationsSaveError': 'Could not save notification settings.',
  'telegram.disconnect': 'Disconnect Telegram',
  'telegram.disconnectConfirm': 'Disconnect Telegram from your account? You can link it again anytime from this page.',
  'telegram.disconnectYes': 'Yes, disconnect',
  'telegram.disconnectCancel': 'Cancel',
  'telegram.coupon.checkoutTitle': 'Connect Telegram and save 20%',
  'telegram.coupon.checkoutBody': "Connect now and we'll apply 20% to this order.",
  'telegram.coupon.checkoutAction': 'Connect Telegram & apply 20%',
  'telegram.coupon.applied': 'Telegram connected — your 20% discount has been applied.',
  'telegram.coupon.replaceConfirm': 'Replace current coupon & apply 20%',
  'telegram.coupon.active': '{percent}% Telegram coupon available.',
  'telegram.coupon.redeemed': 'Telegram coupon used.',
  'telegram.coupon.expired': 'Telegram coupon expired.',
  'telegram.disconnectError': 'Could not disconnect Telegram.',
  'telegram.pref.order_status.label': 'Order status updates',
  'telegram.pref.order_status.description': 'Processing, cancelled, declined, and other status changes.',
  'telegram.pref.shipped.label': 'Shipping and tracking numbers',
  'telegram.pref.shipped.description': 'When your order ships or is re-shipped with a tracking number.',
  'telegram.pref.tracking_updates.label': 'Delivery tracking scans',
  'telegram.pref.tracking_updates.description': 'Carrier updates such as in transit, out for delivery, or delivered.',
  'telegram.pref.payment.label': 'Payment reminders',
  'telegram.pref.payment.description': 'Payment instructions and underpayment notices.',
  'telegram.pref.promotions.label': 'Promotions and offers',
  'telegram.pref.promotions.description': 'Optional discounts and special offers.',

  // ── SignupView ──
  'signup.personalInfo': 'Personal information',
  'signup.title': 'Title',
  'signup.mr': 'Mr.',
  'signup.mrs': 'Mrs.',
  'signup.ms': 'Ms.',
  'signup.firstName': 'First name',
  'signup.lastName': 'Last name',
  'signup.contactInfo': 'Contact information',
  'signup.email': 'E-Mail',
  'signup.phone': 'Phone',
  'signup.billingAddress': 'Billing address',
  'signup.address': 'Address',
  'signup.zipcode': 'Zipcode',
  'signup.city': 'City',
  'signup.country': 'Country',
  'signup.state': 'State',
  'signup.selectCountry': 'Select Country',
  'signup.stateProvince': 'State / Province',
  'signup.selectState': 'Select State',
  'signup.shippingAddress': 'Shipping address',
  'signup.sameAsBilling': 'Same as billing address',
  'signup.privacyInfo': 'Privacy information',
  'signup.password': 'Password',
  'signup.passwordHint': 'Min 5 chars. Must differ from username.',
  'signup.confirmPassword': 'Confirm password',
  'signup.agreeTermsTemplate': "I agree with company's {terms}.",
  'signup.agreeTerms': "I agree with company's Terms & Conditions.",
  'signup.agreeTermsLink': 'Terms & Conditions',
  'signup.firstNameRequired': 'First name is required',
  'signup.lastNameRequired': 'Last name is required',
  'signup.emailRequired': 'Email is required',
  'signup.emailInvalid': 'Invalid email format',
  'signup.phoneRequired': 'Phone is required',
  'signup.addressRequired': 'Address is required',
  'signup.zipcodeRequired': 'Zipcode is required',
  'signup.cityRequired': 'City is required',
  'signup.countryRequired': 'Country is required',
  'signup.passwordRequired': 'Password is required',
  'signup.passwordMinLength': 'Password must be at least 5 characters',
  'signup.passwordMismatch': 'Passwords do not match',
  'signup.termsRequired': 'You must agree to the Terms & Conditions',
  'signup.failed': 'Registration failed',
  'signup.creating': 'Creating account...',
  'signup.createAccount': 'Create Account',

  // ── OrdersView ──
  'orders.loading': 'Loading orders...',
  'orders.loadFailed': 'Failed to load orders',
  'orders.empty': 'No orders yet.',
  'orders.title': 'My Orders',
  'orders.filter': 'Filter:',
  'orders.allTime': 'All Time',
  'orders.thisMonth': 'This Month',
  'orders.thisWeek': 'This Week',
  'orders.today': 'Today',
  'orders.orderId': 'Order ID',
  'orders.date': 'Date',
  'orders.status': 'Status',
  'orders.status_I': 'Not finished',
  'orders.status_Q': 'Queued',
  'orders.status_F': 'Failed',
  'orders.status_P': 'Processed',
  'orders.status_A': 'Approved',
  'orders.status_D': 'Declined',
  'orders.status_S': 'Sent',
  'orders.status_T': 'Resent',
  'orders.status_B': 'Backorder: Out of stock',
  'orders.status_W': 'Backorder: Process Later',
  'orders.status_R': 'Refunded',
  'orders.status_K': 'Justified Chargeback',
  'orders.status_U': 'Unjustified Chargeback',
  'orders.status_J': 'Fraud check failed',
  'orders.status_L': 'Cancelled',
  'orders.status_E': 'Refused',
  'orders.status_C': 'Complete',
  'orders.total': 'Total',
  'orders.pending': 'Pending',
  'orders.detailsLoading': 'Loading details...',
  'orders.detailsFailed': 'Failed to load order details',
  'orders.back': 'Back',
  'orders.backToOrders': 'Back to Orders',
  'orders.details': 'Order details',
  'orders.payNow': 'Pay now',
  'orders.awaitingConfirmation': 'Your order is awaiting confirmation. We will contact you when it is ready for payment.',
  'orders.contactUs': 'Contact us',
  'orders.orderDate': 'Order Date:',
  'orders.orderid': 'Orderid:',
  'orders.statusLabel': 'Status:',
  'orders.paymentMethod': 'Payment method:',
  'orders.shipping': 'Shipping:',
  'orders.trackingNumber': 'Tracking number:',
  'orders.trackingExtra': 'Tracking number EXTRA:',
  'orders.sendDate': 'Send date:',
  'orders.productsInfo': 'Products info',
  'orders.weight': 'Weight',
  'orders.set': 'Set',
  'orders.quantity': 'Quantity',
  'orders.items': 'item(s)',
  'orders.bonusProduct': 'Bonus product',
  'orders.orderInfo': 'Order info',
  'orders.subtotal': 'Subtotal',
  'orders.discount': 'Discount',
  'orders.bonusDiscount': 'Bonus Discount',
  'orders.couponSaving': 'Coupon saving',
  'orders.discountedSubtotal': 'Discounted subtotal',
  'orders.shippingCosts': 'Shipping costs',
  'orders.totalLabel': 'TOTAL',
  'orders.customerInfo': 'Customer Information',
  'orders.personalInfoLabel': 'Personal information:',
  'orders.titleLabel': 'Title',
  'orders.firstNameLabel': 'First Name',
  'orders.lastNameLabel': 'Last Name',
  'orders.billingAddressLabel': 'Billing Address:',
  'orders.addressLabel': 'Address',
  'orders.cityLabel': 'City',
  'orders.stateLabel': 'State',
  'orders.zipcodeLabel': 'Zipcode',
  'orders.countryLabel': 'Country',
  'orders.shippingAddressLabel': 'Shipping Address:',
  'orders.contactInfoLabel': 'Contact information:',
  'orders.phoneLabel': 'Phone',
  'orders.emailLabel': 'E-mail',

  // ── DiscountsView ──
  'discounts.title': 'Your Personal Discount',
  'discounts.description': 'This discount is automatically applied to all your orders.',

  // ── DeleteAccountView ──
  'deleteAccount.thanks': 'Thank you for choosing our service.',
  'deleteAccount.safetyInfo': 'Your privacy matters to us. You can permanently delete your account and related history at any time.',
  'deleteAccount.rules': 'Account deletion rules:',
  'deleteAccount.rule1': 'You should not have any chargebacks in your history.',
  'deleteAccount.rule2': 'At least 21 days must pass after your last successful order.',
  'deleteAccount.attention': 'Attention!',
  'deleteAccount.warning': 'If a chargeback is later received for any order, your account may be restored to process that case. For questions, contact support 24/7.',
  'deleteAccount.password': 'Password',
  'deleteAccount.passwordRequired': 'Password is required.',
  'deleteAccount.reason': 'Reason',
  'deleteAccount.reasonHint': 'Please share your reason for leaving. Your feedback helps us improve.',
  'deleteAccount.reasonRequired': 'Reason is required.',
  'deleteAccount.failed': 'Request failed. Please try again.',
  'deleteAccount.submit': 'Submit',
  'deleteAccount.success': 'Account successfully deleted.',

  // ── BonusAccountPage ──
  'referralProgram.headline': 'Invite a friend. They save {friend}%, you get {reward}% off.',
  'referralProgram.intro': 'Share your personal referral link. After your friend receives their first order, a separate {reward}% off coupon will appear here for your next purchase.',
  'referralProgram.how': 'Your friend gets {friend}% off their first order. You receive a {reward}% off coupon valid for {months} months after that order is shipped.',
  'referralProgram.rulesTitle': 'Coupon rules',
  'referralProgram.ruleSeparate': 'You receive a separate coupon for every new customer you refer.',
  'referralProgram.ruleOnePerOrder': 'Only one coupon can be applied to an order.',
  'referralProgram.ruleNoLimit': 'The {reward}% discount has no maximum savings limit.',
  'referralProgram.couponsTitle': 'Your referral coupons',
  'referralProgram.noCoupons': 'You do not have any referral coupons yet.',
  'referralProgram.apply': 'Apply to cart',
  'referralProgram.applying': 'Applying…',
  'referralProgram.expires': 'Expires',
  'referralProgram.status.active': 'Active',
  'referralProgram.status.redeemed': 'Used',
  'referralProgram.status.expired': 'Expired',
  'referralProgram.status.revoked': 'Unavailable',
  'referralShare.button': 'Share',
  'referralShare.signIn': 'Sign in or create an account to share your personal referral link.',
  'referralShare.signInButton': 'Sign in to share',
  'referralShare.copied': 'Referral link copied.',
  'referralShare.failed': 'Could not share or copy your referral link.',
  'referralShare.ready': 'Your link is ready. Tap Share to send it.',
  'referralCoupon.loginRequired': 'Please sign in to apply your discount coupon.',
  'referralCoupon.applied': 'Your {reward}% off coupon has been applied.',
  'referralCoupon.appliedGeneric': 'Your discount coupon has been applied.',
  'referralCoupon.applyFailed': 'We could not apply this coupon. Please try again from your account.',
  'bonus.headline': 'Earn Lifetime Bonuses with Our Referral Program!',
  'bonus.intro': 'To earn even more benefits from our partnership, we are launching a program that allows you to receive lifetime bonuses for inviting your friends to us. You can use these bonuses to cover up to 50% of your order cost!',
  'bonus.howTitle': 'How does it work?',
  'bonus.howDesc': 'All you need to do is share your referral link (or code) with someone who may be interested in buying from our store! Since this link (or code) is absolutely unique, the system will recognize these new customers as your referral ones and add to your bonus account 15% of their order value immediately after their orders are shipped.',
  'bonus.subsequent': 'For every subsequent order they make, your bonus account will be topped up with an additional 5% of their order value.',
  'bonus.friendBenefits': 'What are the benefits for your friend?',
  'bonus.friendDiscount': 'By using your referral link (or code), they will receive a 20% discount on their first order!',
  'bonus.whyGreat': 'Why this is great for you:',
  'bonus.benefit1': "Your bonuses can be applied to cover up to 50% of your order's cost.",
  'bonus.benefit2': 'Each time your bonus account is credited, you will receive a notification.',
  'bonus.benefit3': "If your friend refers another friend, you'll earn bonuses for their referrals (sub-referrals) as well — 10% of the bonuses your friend earns.",
  'bonus.startSharing': 'Start sharing your referral link today and enjoy the benefits!',
  'bonus.refLinkLabel': 'Your referral link (click to copy)',
  'bonus.copy': 'Copy to clipboard',
  'bonus.copied': 'Copied',
  'bonus.copyFailed': 'Copy failed',
  'bonus.refCodeIntro': 'Alternatively, you can share your unique code, which your referrals can use as a coupon code.',
  'bonus.transactions': 'Bonus Account Transactions',
  'bonus.referralTree': 'Referral Tree',

  // ── BonusTransactionsPage ──
  'bonusTx.loading': 'Loading...',
  'bonusTx.back': 'Back',
  'bonusTx.balance': 'Bonus account:',
  'bonusTx.date': 'Date',
  'bonusTx.addedBonus': 'Added Bonus',
  'bonusTx.usedBonus': 'Used Bonus',
  'bonusTx.type': 'Type',
  'bonusTx.empty': 'There are no transactions in your bonus account yet.',
  'bonusTx.typeM': 'Bonus from a referral purchase',
  'bonusTx.typeC': 'Bonus from a sub-referral purchase',
  'bonusTx.typeO': 'Bonus applied to pay for your order',
  'bonusTx.typeOOrder': 'Bonus applied to pay for your order # {orderId}',
  'bonusTx.typeP': 'Present',
  'bonusTx.typeW': 'Withdrawal',

  // ── ReferralPage ──
  'referral.back': 'Back',
  'referral.loading': 'Loading...',
  'referral.empty': 'No referral data available.',
  'referral.description': 'This section displays the tree of referrals starting from you. It also shows the statistics on the bonuses of a particular referral and his referral branch. Our multi-level marketing system allows you to earn 10% from the referral bonuses of the referrals made by your direct referrals.',
  'referral.referral': 'Referral',
  'referral.bonuses': 'Referral bonuses',
  'referral.subBonuses': 'Sub-referral bonuses',
  'referral.level': 'level:',
  'referral.bonusesNote': 'Referral Bonuses — bonuses from purchases made by your direct referrals.',
  'referral.subBonusesNote': "Sub-referral Bonuses — bonuses from your referrals' referrals.",

  // ── SubscriptionsPage ──
  'subs.loading': 'Loading...',
  'subs.loginRequired': 'Please sign in to manage subscriptions.',
  'subs.empty': 'No newslists available.',
  'subs.instruction': 'Please select/deselect newslist you would like to subscribe/unsubscribe',
  'subs.list.1.name': 'Product discounts',
  'subs.list.1.descr': 'Get discount for interested products. Frequency - monthly',
  'subs.list.2.name': 'Birthday Discounts',
  'subs.list.2.descr': 'Birthday email with a gift. Frequency - annual',
  'subs.list.3.name': 'Refill notice',
  'subs.list.3.descr': 'Refill notification. Frequency - once in two-three month',
  'subs.list.4.name': 'Shop news',
  'subs.list.4.descr': 'Frequency - rarely',

  // ── SubscribeModal (retention opt-in) ──
  'subscribe.title': 'Subscribe for offers',
  'subscribe.subtitle': 'Get exclusive discounts and order reminders',
  'subscribe.cta': 'Subscribe',
  'subscribe.emailLabel': 'Email',
  'subscribe.emailPlaceholder': 'your@email.com',
  'subscribe.phoneLabel': 'Phone',
  'subscribe.phonePlaceholder': '+1 234 567 8900',
  'subscribe.consentLabel': 'I agree to receive promotional emails and order reminders',
  'subscribe.consentRequired': 'Please agree to receive emails',
  'subscribe.invalidEmail': 'Please enter a valid email',
  'subscribe.success': 'Thank you! You are subscribed.',
  'subs.success': 'Subscriptions updated',
  'subs.failed': 'Update failed.',
  'subs.updating': 'Updating...',
  'subs.update': 'Update',

  // ── TicketsView ──
  'tickets.loading': 'Loading tickets...',
  'tickets.loadingMore': 'Loading more...',
  'tickets.refresh': 'Refresh',
  'tickets.openNew': 'Open new ticket',
  'tickets.empty': "No tickets found at the moment. Use 'Open new ticket' to ask a question",
  'tickets.subject': 'Subject',
  'tickets.status': 'Status',
  'tickets.date': 'Date',
  'tickets.lastReply': 'Last Reply',
  'tickets.statusAwaitingUser': 'Awaiting user',
  'tickets.statusAwaitingAgent': 'Awaiting agent',
  'tickets.statusPending': 'Pending',
  'tickets.statusResolved': 'Resolved',
  'tickets.detailLoading': 'Loading ticket...',
  'tickets.notActivated': 'Ticket system not activated for your account.',
  'tickets.loadFailed': 'Failed to load ticket',
  'tickets.unavailable': 'Support tickets are temporarily unavailable. Please try again later or contact support by email if urgent.',
  'tickets.backToTickets': 'Back to Tickets',
  'tickets.title': 'Support tickets',
  'tickets.dateLabel': 'Date:',
  'tickets.statusLabel': 'Status:',
  'tickets.resolve': 'Resolve Ticket',
  'tickets.resolveConfirm': 'Are you sure you want to resolve this ticket?',
  'tickets.resolveFailed': 'Failed to resolve ticket',
  'tickets.replyFailed': 'Failed to send reply',
  'tickets.noMessages': 'No messages found.',
  'tickets.messagesHeading': 'Messages',
  'tickets.messageFromSupport': 'Support',
  'tickets.messageFromYou': 'You',
  'tickets.replyHeading': 'Reply',
  'tickets.message': 'Message',
  'tickets.uploadFiles': 'Upload files (PDF, JPG, PNG, TXT)',
  'tickets.attachFiles': 'Attach files',
  'tickets.filesCount': '{count} file(s)',
  'tickets.fileLimit': 'Select up to 3 files.',
  'tickets.sendReply': 'Send reply',
  'tickets.newTicketTitle': 'Open New Ticket',
  'tickets.newSubject': 'Subject',
  'tickets.newMessage': 'Message',
  'tickets.newUpload': 'Upload files (PDF, JPG, PNG, TXT)',
  'tickets.submitTicket': 'Submit Ticket',
  'tickets.createSuccess': 'Ticket created successfully',
  'tickets.createFailed': 'Failed to create ticket',
  'tickets.authNotActivated': 'The ticket system has not yet been activated for your account.',
  'tickets.authInstructions': 'If you wish to activate it, please click the button below, and we will email you the instructions.',
  'tickets.sendActivation': 'Send activation email',
  'tickets.activationSuccess': 'Activation email sent successfully',
  'tickets.activationFailed': 'Failed to send activation email',

  // ── Pagination ──
  'pagination.label': 'Orders pagination',
  'pagination.first': 'First',
  'pagination.previous': 'Previous',
  'pagination.next': 'Next',
  'pagination.last': 'Last',

  // ── SearchableSelect ──
  'select.search': 'Search...',
  'select.noResults': 'No results found',
  'select.placeholder': 'Select...',

  // ── Months ──
  'month.1': 'January', 'month.2': 'February', 'month.3': 'March',
  'month.4': 'April', 'month.5': 'May', 'month.6': 'June',
  'month.7': 'July', 'month.8': 'August', 'month.9': 'September',
  'month.10': 'October', 'month.11': 'November', 'month.12': 'December',

  // ── ContactPage ──
  'contact.title': 'Contact Us',
  'contact.unavailable': 'Contact information is not available.',
  'contact.email': 'Email',
  'contact.phone': 'Phone',
  'contact.live_chat': 'Live chat',
  'contact.start_chat': 'Start chat',
  'contact.hours': 'Working Hours',
  'contact.previewHours': 'Mon-Fri 9:00-18:00',
  'contact.support247': 'Support 24/7',
  'contact.tickets_title': 'Support Tickets',
  'contact.tickets_desc': 'Have a question? Open a support ticket and we\'ll get back to you.',
  'contact.open_ticket': 'Open a ticket',
  'contact.formTitle': 'Send us a message',
  'contact.loginRequired': 'Please log in to submit a support ticket.',
  'testimonials.customer': 'Customer',
  'testimonials.loading': 'Loading testimonials...',
  'testimonials.empty': 'No testimonials yet.',
  'testimonials.loadError': 'Unable to load testimonials. Please try again later.',
  'testimonials.formTitle': 'Leave a testimonial',
  'testimonials.namePlaceholder': 'Your name',
  'testimonials.messagePlaceholder': 'Your review',
  'testimonials.submitting': 'Submitting...',
  'testimonials.submit': 'Submit review',
  'testimonials.submitError': 'Unable to submit testimonial.',
  'testimonials.loginRequired': 'Please log in to leave a testimonial.',
  'testimonials.validationName': 'Name must be at least 2 characters.',
  'testimonials.validationMessage': 'Review must be at least 6 characters.',
  'testimonials.success': 'Thank you for your review! It will appear after moderation.',
  'contact.requestFrom': 'Request will be sent from',
  'contact.unknownUser': 'Authenticated user',
  'contact.subject': 'Subject',
  'contact.subjectPlaceholder': 'How can we help?',
  'contact.message': 'Message',
  'contact.messagePlaceholder': 'Describe your issue...',
  'contact.send': 'Send Message',
  'contact.ticketsLoginRequired': 'Sign in to view and submit support tickets.',
  'chat.online': 'Online',
  'chat.offline': 'Offline',
  'chat.coming_soon': 'Live chat is being set up. Please use email or phone for now.',
  'chat.offline_message': 'Our operators are currently offline.',
  'chat.leave_message': 'Please leave a message and we\'ll get back to you.',
  'chat.leave_ticket': 'Leave us a ticket',
  'nav.login': 'Sign In',
  'nav.signup': 'Create Account',
  'miniCart.deliveryMethod': 'Delivery method',

  // ── API errors (ShopApiService::$statusCodes) ──
  'api.genericError': 'An error occurred. Please try again later.',
  'api.networkError': 'Service temporarily unavailable. Check your connection or try again later.',
  'api.error.10503': 'Service Unavailable',
  'api.error.20002': 'Client auth params validation failed',
  'api.error.20004': 'Client config not found',
  'api.error.20005': 'IP or domain restriction',
  'api.error.20006': 'Client not granted to use the function',
  'api.error.20007': 'Signature is invalid',
  'api.error.40001': 'The customer authentication failed',
  'api.error.40004': 'The customer data validation failed',
  'api.error.40008': 'The customer login already exists',
  'api.error.40009': 'The customer email already exists',
  'api.error.40021': 'The customer account already exists',
  'api.error.40022': 'Customer not found',
  'api.error.400014': 'The coupon is invalid',
  'api.error.50001': 'The customer account fraud check failed',
  'api.error.50002': 'The customer has open orders. The account cannot be deleted.',
  'api.error.60001': 'Unfortunately, this product cannot be delivered to your shipping country.',
  'geo.soft_notice': 'This product has delivery region limits. Final availability is confirmed after sign-in using your shipping address.',
  'api.error.60101': 'This order allows up to {limit} different product(s). Older items may be replaced when you add another.',
  'api.error.60102': 'Maximum quantity for this product is {limit}.',
  'api.error.60103': 'Maximum packs for this product is {limit}.',
  'unsubscribe.processing': 'Processing…',
  'unsubscribe.success': 'You have been unsubscribed from marketing emails from {shop_name}.',
  'unsubscribe.shop': 'Shop',
  'unsubscribe.invalidLink': 'Invalid or expired link.',
  'unsubscribe.error': 'An error occurred.',
  'subscribeConfirm.processing': 'Processing…',
  'subscribeConfirm.success': 'Your subscription to {shop_name} is confirmed.',
  'subscribeConfirm.invalidLink': 'Invalid or expired link.',
  'subscribeConfirm.error': 'An error occurred.',

  // ── Generic ──
  'close': 'Close',
  'loading': 'Loading...',
  'yes': 'Yes',
  'no': 'No',
  'paymentMethod.credit_card_amex': 'Credit Card (Amex)',
  'paymentMethod.credit_card': 'Credit Card',
  'paymentMethod.echeque': 'E-check',
  'paymentMethod.bitcoin': 'Bitcoin',
  'paymentCard.amex': 'Amex',
  'paymentCard.mc': 'MasterCard',
  'paymentCard.visa': 'Visa',
};
